import { Component, OnInit } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { Rekbot } from '../../models/rekbot.model';
import { UserRekbotService } from '../../services/user-rekbot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RekbotsService } from '../../services/rekbots.service';
import { User } from '../../models/user.model';
import { NotificationService } from '../../services/notification.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { RekbotListSmallComponent } from '../../rekbots/rekbot-list-small/rekbot-list-small.component';
import { UserRekbotListSmallComponent } from '../../rekbots/user-rekbot-list-small/user-rekbot-list-small.component';

@Component({
  selector: 'app-user-rekbot',
  imports: [
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    CommonModule,
    MatCardModule,
    MatProgressBarModule,
    MatButtonModule,
    //RekbotListSmallComponent,
    UserRekbotListSmallComponent
  ],
  templateUrl: './user-rekbots.component.html',
  styleUrl: './user-rekbots.component.css'
})
export class UserRekbotsComponent implements OnInit {

  public isLoading: boolean = false;

  public rekbotList: Rekbot[];
  public userId: number = 0;

  public userRekbots: any[];
  public user: User;

  public selectedRekbotIds: any[] = [];

  constructor(
    private userRekbotService: UserRekbotService,
    private rekbotService: RekbotsService,
    private route: ActivatedRoute,
    public router: Router,
    private notificationService: NotificationService,

  ) {

    this.rekbotList = [];
    this.userRekbots = [];
    this.user = new User(0, "", "", "", 0, "", "");

  }

  ngOnInit(): void {

    this.userId = this.route.snapshot.params['userId'];

    this.rekbotService.fetchRekbots()
      .subscribe({
        next: (response: any) => {
          //console.log("fetchRekbots response", response)
          this.rekbotList = response /*.map((item: Rekbot) => {
            return {
              name: item.serial_no,
              value: item.id
            }
          })*/
        },
        error: error => {
          console.log("Error fetchRekbots", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }

        }
      })


    if (this.userId > 0) {
      this.userRekbotService.getUserRekbots(this.userId)
        .subscribe({
          next: (response: any) => {
            console.log("getUserRekbots response", response)
            this.userRekbots = <Rekbot[]>response.user.rekbots.map((el: Rekbot) => {
              return el.id
            })

            this.user = <User>response.user;

            console.log("this.userRekbots selected userRekbors", this.userRekbots)
          },
          error: (error) => {
            console.log("Error getUserRekbots", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        })
    }
  }

  saveAssignedRekbots() {

    //console.log("saveAssignedRekbots", this.userRekbots)

    if (this.userId > 0) {
      this.userRekbotService.saveUserRekbots(this.userId, this.userRekbots)
        .subscribe({
          next: (response: any) => {
            console.log("saveUserRekbots response", response)

            this.notificationService.pushNotification(
              `Rekboty użytkownika zaktualizowane`, 'info', 5000);

          },
          error: (error) => {

            console.log("Error saveUserRekbots", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }

            this.notificationService.pushNotification(
              `Nie udało się zmienić konfiguracji`, 'error', 5000);

          }
        })
    }


  }


}
